import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  TextField,
  Link,
  Grid,
  Container,
  Typography,
} from "@material-ui/core";
import "./login.css";
import TsiLogo from "../assets/logo.png";
import CCTV from "../assets/loginbg.jpg";
import { fetchMethod } from "../../FetchMethod";
import { ResetPassword } from "../../config";
import { ChangePassword } from "./LoginQueries";
import swal from "sweetalert";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    const token = localStorage.getItem("token");
    let loggedIn = true;
    if (token == null) {
      loggedIn = false;
    }

    this.state = {
      email: "",
      email1: "",
      password1: "",
      userData: undefined,
      id: undefined,

      password: undefined,
      loading: false,
      forgot: true,
      errors: { email: "" },
    };
  }

  handleChange = (e) => {
    
    if (e.target.id === "email") {
      this.setState({ email: e.target.value });
    }
  };
  validateForm = (email) => {
   
    const { errors } = this.state;
    const validEmailRegex = RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    errors.email = validEmailRegex.test(email.trim())
      ? ""
      : "Email is not valid!";
    this.setState({ errors });
    return this.state.errors.email === "Email is not valid!" ? false : true;
  };

  handleClickShowPassword = () => {
    
    this.setState({ showPassword: !this.state.showPassword });
  };

  onSubmit = (e) => {
   
    e.preventDefault();

    if (this.state.email === "") {
      swal({
        icon: "warning",
        title: "Please enter Email-ID ",
      });
    }
    if (this.validateForm(this.state.email)) {
      fetch(`${ResetPassword.url}` + `${localStorage.getItem("email")}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.response[0].id !== undefined && res.response[0].id !== null) {
            this.setState(
              {
                id: res.response[0].id,
                password: res.response[1],
              },
              () => this.SendPassword()
            );
          } else {
            swal("This email does not exist", { icon: "error" });
          }
        })
        .catch((e) => {
          this.setState({ loading: true });
        });
    }
  };
  SendPassword = () => {
    const reset = {
      id: this.state.id,
      newPassword: this.state.password,
    };
    fetchMethod(ChangePassword, reset)
      .then((res) => res.json())
      .then((response) => {
        if (response.data.UsersdataSetPassword === null) {
          swal({
            icon: "success",
            title:
              "New password has been sent to the email address" +
              "\n" +
              localStorage.getItem("email"),
          }).then((willOk) => {
            window.location = "/";
          });
        } else {
          this.setState({ loading: true });
        }
      })
      .catch((e) => this.setState({ loading: true }));
  };

  render() {
    localStorage.setItem("email", this.state.email);
    return (
      <div
        className="loginFormContainer Forgot"
        style={{ backgroundImage: `url(${CCTV})` }}
      >
        <Container className="container" maxWidth="xs">
          <div>
            <form className="form loginForm" onSubmit={this.onSubmit}>
              <div className="circleForm"></div>

              <img src={TsiLogo} />
              <Typography variant="body2" color="inherit" align="center">
                A common platform to manage all LinkedIn <br /> campaign
                solutions!
              </Typography>
              <TextField
                value={this.state.email}
                variant="outlined"
                margin="normal"
                fullWidth
                id="email"
                label="Registered Email Address"
                name="email"
                autoComplete="email"
                InputLabelProps={{
                  shrink: true,
                }}
                autoFocus
                onChange={this.handleChange}
                placeholder="e.g. example@gmail.com"
              />
              {this.state.errors.email.length > 0 && (
                <span
                  className="error"
                  style={{
                    color: "red",
                    fontSize: "13px",
                  }}
                >
                  {this.state.errors.email}
                </span>
              )}
              <Typography
                variant="body2"
                style={{ color: "#ffa062", fontSize: "11px" }}
              >
                "New password" will be sent to the above mentioned email
                address!
           
              </Typography>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ backgroundColor: "#273c75", marginTop: "30px" }}
                className="submit"
              >
                Send Me Link
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link
                    href="/"
                    style={{ cursor: "pointer" }}
                    variant="body2"
                  >
                    Back To Login
                  </Link>
                </Grid>
              </Grid>
            </form>
          </div>
        </Container>
      </div>
    );
  }

  handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
}
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(null, mapDispatchToProps)(ForgotPassword);
